
import { useRouter, useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import { PermissionMap } from '@/utils/auth'
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { debounce } from '@/utils/common'
import {
  getEnjoySongVersions,
  deleteEnjoySongVersion,
  setEnjoyVersionTest,
  setEnjoyVersionDevelop,
  setEnjoyVersionProduction
} from '@/services/songs'
import ResourceVersionTag from '@/components/common/ResourceVersionTag'

export default {
  name: 'VersionList',
  components: {
    ResourceVersionTag
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const pageData = reactive({
      type: 1,
      firstLoading: true,
      advanced: false,
      tagParams: {
        pageSize: 50,
        page: 1,
        keyword: ''
      },
      modalVisible: false
    })
    const tableState = reactive({
      data: [],
      columns: [],
      loading: true,
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10,
        showTotal: total => `共${total}条`,
        showQuickJumper: true
      }
    })
    tableState.columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 120
      },
      {
        title: '歌曲名称',
        dataIndex: 'name',
        ellipsis: true,
        width: 200
      },
      {
        title: '歌曲识别码',
        dataIndex: 'song_code',
        width: 140
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        width: 100,
        ellipsis: true
      },
      {
        title: '版本类型',
        dataIndex: 'version_type',
        width: 200,
        slots: { customRender: 'version_type' }
      },
      {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '更新时间',
        dataIndex: 'updated_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 440,
        slots: { customRender: 'action' }
      }
    ]

    const getList = debounce(async (params) => {
      tableState.loading = true
      params = { page: 1, ...params, enjoy_song_id: route.params.id }
      const { items, pagination } = await getEnjoySongVersions(params)
      tableState.data = items
      tableState.loading = false
      tableState.pagination = { ...tableState.pagination, ...pagination }
    })
    const handleBack = () => {
      history.go(-1)
    }
    const handleJumpInfo = (record) => {
      router.push(`/resource/enjoy-songs/${route.params.id}/version-detail/${record.id}`)
    }
    const handleTableChange = (pag) => {
      tableState.pagination = pag
      getList({ page: tableState.pagination.current })
    }
    const handleCreate = () => {
      router.push(`/resource/enjoy-songs/${route.params.id}/edit/${pageData.type}`)
    }
    const handleDelete = async (record) => {
      await deleteEnjoySongVersion(record.id)
      message.success('操作成功')
      getList()
    }

    onBeforeMount(async () => {
      await Promise.all([
        getList()
      ])
      pageData.firstLoading = false
    })

    const setTest = async (record) => {
      await setEnjoyVersionTest(record.id)
      message.success('设置成功')
      getList()
    }
    const setDev = async (record) => {
      await setEnjoyVersionDevelop(record.id)
      message.success('设置成功')
      getList()
    }
    const setProd = async (record) => {
      await setEnjoyVersionProduction(record.id)
      message.success('设置成功')
      getList()
    }

    return {
      tableState,
      pageData,
      PermissionMap,
      handleJumpInfo,
      handleBack,
      handleTableChange,
      handleCreate,
      handleDelete,
      setTest,
      setProd,
      setDev
    }
  }
}
